"use client";

import Image from 'next/image';
import Link from 'next/link';
import { useSidebarContext } from "@/components/ui/sidebar";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";
import { useEffect, useState } from 'react';

export function Logo({ className }: { className?: string }) {
  const { collapsed } = useSidebarContext();
  const { theme, systemTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  
  // Wait until mounted to avoid hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);
  
  const logos = {
    dark: {
      full: '/GreenLogo.png',
      icon: '/IconGreen.png'
    },
    light: {
      full: '/BlackLogo.png',
      icon: '/IconBlack.png'
    }
  };

  // Default to light theme during SSR to match server render
  const currentTheme = mounted ? (theme === 'system' ? systemTheme : theme) : 'light';
  const logoSrc = collapsed ? logos[currentTheme === 'dark' ? 'dark' : 'light'].icon : logos[currentTheme === 'dark' ? 'dark' : 'light'].full;

  return (
    <Link href="/" className="flex items-center justify-center h-full">
      <div className={cn(
        "relative group flex items-center justify-center",
        collapsed ? "h-10 w-10" : "h-10 w-44"
      )}>
        {/* Enhanced glow effect */}
        <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-pink-500/20 opacity-0 blur-lg transition-all duration-500 group-hover:opacity-100 -z-10" />
        <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-blue-500/10 via-purple-500/10 to-pink-500/10 opacity-0 blur-2xl transition-all duration-500 group-hover:opacity-100 -z-10" />
        
        {/* Logo with scale effect */}
        <div className="relative transition-all duration-300 ease-out group-hover:scale-105">
          <Image
            src={logoSrc}
            alt="TerraSync"
            width={collapsed ? 40 : 180}
            height={collapsed ? 40 : 45}
            className={className}
            quality={100}
            priority
            style={{
              objectFit: 'contain',
              transform: 'none',
            }}
          />
        </div>
      </div>
    </Link>
  );
} 